import { render } from "./OmMig.vue?vue&type=template&id=91de53a4"
import script from "./OmMig.vue?vue&type=script&lang=js"
export * from "./OmMig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__